export default __webpack_public_path__ + "static/media/Claymore of the Raging Earth.5d23523c.jpg";